import React from 'react';

import { usePageTitle } from '../../hooks';

export const PageTitleUpdater: React.FC = () => {
	usePageTitle();
	return null;
};
